import { useLazyPostCall } from 'common/api/useApiCall';
import { URLS } from 'constants/URL';
import { useEffect, useMemo, useState } from 'react';
import { adaptSubscriptionsToCloudCommandDropdownOptions } from './helper';
import { CloudCommandsDropDownOptionsDataInterface } from './types';

export const useCloudCommands = ({ tenant }) => {
  const { subscriptions, _id: tenantId, pgSource } = tenant;
  const [output, setOutput] = useState([]);
  const [command, setCommand] = useState<string>('');
  const dropDownOptionsData: CloudCommandsDropDownOptionsDataInterface =
    useMemo(
      () => adaptSubscriptionsToCloudCommandDropdownOptions(subscriptions),
      [subscriptions],
    );

  const [selectedSubscription, setSelectedSubscription] = useState(
    dropDownOptionsData?.subscriptionOptions?.[0]?.label || '',
  );
  const [selectedCloud, setSelectedCloud] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);

  const { postData, response, isLoading } = useLazyPostCall(
    `${URLS.fetchCloudCLI}?tenant-id=${tenantId}&tenant-domain=${pgSource}`,
    null,
    true,
  );

  const handleCommand = () => {
    setOutput((prevOutput) => [
      ...prevOutput,
      [`Command: ${command}`, null],
      ['Output: ', null],
    ]);
    const payload = {
      command,
      region: selectedRegion,
      cloudAccountId: selectedCloud,
      commandType: 'READ',
    };
    postData(JSON.stringify(payload));
  };

  useEffect(() => {
    if (response?.response && Array.isArray(response?.response)) {
      setOutput((prevOutput) => [
        ...prevOutput,
        ...[[response?.response || [], response?.statusCode || null]],
      ]);
    }
  }, [response]);

  const clearScreen = () => setOutput([]);

  useEffect(() => {
    if (selectedSubscription) {
      setSelectedCloud(
        dropDownOptionsData?.subscriptionToCloudMap?.[selectedSubscription]?.[0]
          ?.cloudAccountId,
      );
    }
  }, [selectedSubscription]);

  useEffect(() => {
    if (selectedCloud) {
      setSelectedRegion(
        dropDownOptionsData?.cloudAccountIdToRegionsMap?.[selectedCloud]?.[0],
      );
    }
  }, [selectedCloud]);

  return {
    output,
    command,
    dropDownOptionsData,
    isLoading,
    selectedSubscription,
    selectedCloud,
    selectedRegion,
    setSelectedRegion,
    setCommand,
    handleCommand,
    setSelectedCloud,
    setSelectedSubscription,
    clearScreen,
  };
};
